import { useQueryClient } from "@tanstack/react-query";

import orderCore from "../../core/order.core";
import { useTranslation } from "../../core/translation.core";
import { Order } from "../../types/order";
import UpdateBadge from "../form/updateBadge.comp";

export default function OrderStatusEditor({ order }: { order: Order }) {
  const { t, msg } = useTranslation();
  const queryClient = useQueryClient();

  const options = [
    { value: "pending", label: t(msg.order.pending), css: "text-white bg-blue-700" },
    { value: "processing", label: t(msg.order.processing), css: "text-white bg-blue-700" },
    { value: "shipped", label: t(msg.order.shipped), css: "text-white bg-blue-700" },
    { value: "delivered", label: t(msg.order.delivered), css: "text-white bg-blue-700" },
    { value: "cancelled", label: t(msg.order.cancelled), css: "text-white bg-blue-700" },
    { value: "returned", label: t(msg.order.returned), css: "text-white bg-blue-700" },
  ];

  async function updateStatus(status: string) {
    await orderCore.updateOrder({
      orderId: order.id,
      data: {
        orderStatus: status,
      },
      queryClient,
    });
  }

  if (!order.status) return null;

  return (
    <div>
      <UpdateBadge currentValue={order.status} options={options} onUpdate={updateStatus} />
    </div>
  );
}
